import AppContext from "PFApp/app_context";
import {
  PROFILE_COMPLETION_COLORS,
  ProfileCompletionLevel,
  ProfileCompletionThresholds
} from "PFApp/constants/profile_completion_levels";
import { useContext } from "react";

type UseProfileCompletionReturn = {
  completionLevel: ProfileCompletionLevel;
  completionValue: number;
  completionColor: string;
};

export const useProfileCompletionLevel = (): UseProfileCompletionReturn => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const completionValue = currentProfile?.statistics?.progress_completion || 0;
  const [, completionLevel] = Object.entries(ProfileCompletionThresholds).find(
    ([threshold]) => completionValue <= parseInt(threshold)
  )!;

  const completionColor = PROFILE_COMPLETION_COLORS[completionLevel];

  return { completionLevel, completionValue, completionColor };
};
